import React, { useState, useCallback, useEffect } from 'react'
import useStyles from './style'
import {
  Grid,
  Typography,
  IconButton,
  Grow,
  Box,
  Tabs,
  Tab,
} from '@mui/material'
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import { Navigation } from 'swiper'
import { API_ENDPOINTS } from 'constants'
import _ from 'lodash'
import VisibilitySensor from 'react-visibility-sensor'
import productsApi from 'services/products'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'

// const tabList = [
//   { title: 'Gold', tabIndex: 0 },
//   { title: 'Silver', tabIndex: 1 },
// ]

function TabPanel(props) {
  const { children, value, index, ...other } = props
  const classes = useStyles()
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={classes.box}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

// const list = [
//   {
//     id: 1,
//     category: [
//       {
//         id: 1,
//         img: '/assets/images/category/necklace.webp',
//         name: 'Necklaces',
//       },
//       { id: 2, img: '/assets/images/category/earring.webp', name: 'Earrings' },
//       { id: 3, img: '/assets/images/category/bracelet.webp', name: 'Braclets' },
//       { id: 4, img: '/assets/images/category/ring.webp', name: 'Rings' },
//     ],
//   },
//   {
//     id: 2,
//     category: [
//       { id: 5, img: '/assets/images/category/bangle.jpg', name: 'Bangles' },
//       { id: 6, img: '/assets/images/category/anklet.jpg', name: 'Anklets' },
//       { id: 7, img: '/assets/images/category/nosepin.jpg', name: 'Nosepin' },
//     ],
//   },
// ]

const list = [
  {
    id: 1,
    img: '/assets/images/category/necklace.webp',
    name: 'Necklaces',
  },
  { id: 2, img: '/assets/images/category/earring.webp', name: 'Earrings' },
  { id: 3, img: '/assets/images/category/bracelet.webp', name: 'Braclets' },
  { id: 4, img: '/assets/images/category/ring.webp', name: 'Rings' },
  { id: 5, img: '/assets/images/category/bangle.jpg', name: 'Bangles' },
  { id: 6, img: '/assets/images/category/anklet.jpg', name: 'Anklets' },
  { id: 7, img: '/assets/images/category/nosepin.jpg', name: 'Nosepin' },
]

const ShopCategorySlider = (props) => {
  const { shopbycatProcess } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isVisible, setIsVisible] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [tabObj, setTabObj] = useState(null)
  const [mainCategoryOptions, setMainCategoryOptions] = useState([])
  const [subCategoryOptions, setSubCategoryOptions] = useState([])

  const onVisibilityChange = (isVisible) => {
    setIsVisible(isVisible)
  }

  const handleTabs = (event, index) => {
    setTabValue(index)
  }

  //Get main category options api
  const getMainCategory = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        const addedTabValuesArr = res?.data?.data?.results?.map(
          (data, idx) => ({ ...data, tabIndex: idx })
        )
        setMainCategoryOptions(addedTabValuesArr)
      } else {
        setMainCategoryOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get main category options Api', err)
    }
    productsApi.getMainCategory().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getMainCategory()
  }, [getMainCategory])

  //Get sub category options api
  const getSubCategory = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setSubCategoryOptions(res?.data?.data)
      } else {
        setSubCategoryOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get sub category options Api', err)
    }
    !_.isEmpty(tabObj?._id) &&
      productsApi.getSubCategory(tabObj?._id).then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabObj])
  useEffect(() => {
    getSubCategory()
  }, [getSubCategory])

  // set current tab object
  useEffect(() => {
    const findCurrentTab = mainCategoryOptions?.find(
      (data) => data?.tabIndex === tabValue
    )

    setTabObj(findCurrentTab)
  }, [mainCategoryOptions, tabValue])

  //Handle Sub Category navigation
  const handleCategoryNavigate = (mainCategory, subCategory) => {
    mainCategory &&
      subCategory &&
      navigate(`/shop/${mainCategory}/${subCategory}`)
  }

  return (
    <>
      {!_.isEmpty(mainCategoryOptions) && !_.isEmpty(subCategoryOptions) ? (
        <Grid container className={classes.root}>
          <Grid item xs={12} className={classes.title}>
            <Typography variant="h2">Shop By Category</Typography>
          </Grid>
          <Grid item xs={12} className={classes.tabWrapper}>
            <Tabs
              value={tabValue}
              onChange={handleTabs}
              aria-label="shopByCategory"
              variant="scrollable"
              scrollButtons="auto"
              className={classes.tabLabels}
            >
              {mainCategoryOptions?.map(({ name, tabIndex, disabled }) => (
                <Tab label={name} {...a11yProps({ tabIndex })} key={tabIndex} />
              ))}
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {mainCategoryOptions?.map((__, index) => (
              <TabPanel value={tabValue} index={index}>
                <Grid item xs={12}>
                  <section>
                    {_.isEmpty(subCategoryOptions) ? (
                      <>
                        {" "}
                        <div className={classes.emptyData}>
                          <Typography variant="h6">
                            No Categories is added yet for {tabObj?.name}
                          </Typography>
                        </div>{" "}
                      </>
                    ) : (
                      <VisibilitySensor
                        onChange={onVisibilityChange}
                        partialVisibility={true}
                      >
                        <section className={classes.sliderWrapper}>
                          <section className="prev">
                            <IconButton
                              sx={{ background: "#fff" }}
                              size="small"
                              component="div"
                            >
                              <KeyboardArrowLeftOutlinedIcon
                                className={classes.icon}
                              />
                            </IconButton>
                          </section>
                          <Swiper
                            navigation={{
                              prevEl: ".prev",
                              nextEl: ".next",
                              clickable: true,
                            }}
                            slidesPerView={5}
                            // navigation={true}
                            modules={[Navigation]}
                            grabCursor={true}
                            className="mySwiper"
                            spaceBetween={16}
                            breakpoints={{
                              50: {
                                slidesPerView: 1,
                              },
                              370: {
                                slidesPerView: 2,
                              },
                              600: {
                                slidesPerView: 3,
                              },
                              900: {
                                slidesPerView: 4,
                              },
                              1200: {
                                slidesPerView: 5,
                              },
                            }}
                          >
                            {subCategoryOptions?.map((data) => (
                              <SwiperSlide key={data?.id}>
                                <Grow
                                  in={isVisible}
                                  timeout={1500}
                                  unmountOnExit
                                >
                                  <section
                                    className={classes.cardWrapper}
                                    onClick={() =>
                                      handleCategoryNavigate(
                                        tabObj?.name?.toLowerCase(),
                                        data?.name?.toLowerCase()
                                      )
                                    }
                                  >
                                    <div className={classes.imgContainer}>
                                      <img
                                        src={
                                          API_ENDPOINTS?.FILE_URL + data?.image
                                        }
                                        alt={data?.name}
                                        className={classes.img}
                                      />
                                    </div>
                                    <div className={classes.label}>
                                      <Typography variant="body1">
                                        {data?.name}
                                      </Typography>
                                    </div>
                                  </section>
                                </Grow>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                          <section className="next">
                            <IconButton
                              sx={{ background: "#fff" }}
                              size="small"
                              component="div"
                            >
                              <KeyboardArrowRightOutlinedIcon
                                className={classes.icon}
                              />
                            </IconButton>
                          </section>
                        </section>
                      </VisibilitySensor>
                    )}
                  </section>
                </Grid>{" "}
              </TabPanel>
            ))}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}

export default ShopCategorySlider
